__turbopack_context__.v({
  "bar": "StreamsRangeInput-module-scss-module__mq4mya__bar",
  "hud": "StreamsRangeInput-module-scss-module__mq4mya__hud",
  "right": "StreamsRangeInput-module-scss-module__mq4mya__right",
  "slider": "StreamsRangeInput-module-scss-module__mq4mya__slider",
  "stat": "StreamsRangeInput-module-scss-module__mq4mya__stat",
  "wrap": "StreamsRangeInput-module-scss-module__mq4mya__wrap",
});
